// File: frontend/src/services/adminLegalService.ts

import { apiClient } from "./apiClient";
import { LegalDocType } from "./legalService";

/**
 * Admin-side view of one legal document.
 *
 * Carries both bodies: `body` is the raw authoring source the editor writes
 * into, `renderedBody` is the same text with {{setting:...}} / {{const:...}}
 * tokens resolved, so the preview needs no second request.
 */
export interface AdminLegalDocument {
    id:                 number;
    docType:            LegalDocType;
    language:           string;
    title:              string;
    body:               string;
    renderedBody:       string;
    version:            string;
    effectiveDate:      string | null;
    published:          boolean;
    updatedAt:          string | null;
    updatedByUsername:  string | null;
}

/** Payload for PUT /api/admin/legal/{id}. Type and language are immutable. */
export interface AdminLegalUpdateRequest {
    title:          string;
    body:           string;
    version:        string;
    effectiveDate:  string | null;
    published:      boolean;
}

/** All six documents (3 types × 2 languages), ordered by type then language. */
export const getAdminLegalDocuments = (): Promise<AdminLegalDocument[]> =>
    apiClient.get<AdminLegalDocument[]>("/api/admin/legal");

/** Save one document and receive it back with a freshly rendered preview. */
export const updateAdminLegalDocument = (
    id: number,
    request: AdminLegalUpdateRequest
): Promise<AdminLegalDocument> =>
    apiClient.put<AdminLegalDocument>(`/api/admin/legal/${id}`, request);